(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ========================================
       ANNOUNCEMENT BAR — dismiss + cookie
       ======================================== */
    var bar = document.getElementById('announcement-bar');
    var closeBtn = document.getElementById('announcement-close');
    if (bar && document.cookie.includes('announcement_dismissed=1')) {
      bar.classList.add('is-hidden');
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (bar) {
          bar.classList.add('is-hidden');
          document.cookie = 'announcement_dismissed=1;path=/;max-age=86400';
        }
      });
    }

    /* ========================================
       STICKY HEADER — scroll effect
       ======================================== */
    var header = document.getElementById('site-header');
    if (header) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 50) {
          header.classList.add('site-header--scrolled');
        } else {
          header.classList.remove('site-header--scrolled');
        }
      }, { passive: true });
    }

    /* ========================================
       HAMBURGER — mobile nav toggle
       ======================================== */
    var hamburger = document.getElementById('hamburger-toggle');
    var mobileNav = document.getElementById('mobile-nav');
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('is-open');
        hamburger.setAttribute('aria-expanded', open);
      });
    }

    /* ========================================
       MOBILE SUBMENU — expand / collapse
       ======================================== */
    document.querySelectorAll('.site-header__mobile-expand').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.dataset.target);
        if (target) {
          target.classList.toggle('is-open');
          btn.classList.toggle('is-expanded');
        }
      });
    });

    /* ========================================
       SEARCH DRAWER — open / close
       ======================================== */
    var searchToggle = document.getElementById('search-toggle');
    var searchDrawer = document.getElementById('search-drawer');
    var searchClose = document.getElementById('search-close');
    if (searchToggle && searchDrawer) {
      searchToggle.addEventListener('click', function () {
        searchDrawer.classList.toggle('is-open');
        if (searchDrawer.classList.contains('is-open')) {
          var input = searchDrawer.querySelector('input');
          if (input) input.focus();
        }
      });
    }
    if (searchClose && searchDrawer) {
      searchClose.addEventListener('click', function () {
        searchDrawer.classList.remove('is-open');
      });
    }

    /* ========================================
       QUANTITY CONTROLS — +/- buttons
       ======================================== */
    document.querySelectorAll('.qty-control').forEach(function (control) {
      var minus = control.querySelector('.qty-minus');
      var plus = control.querySelector('.qty-plus');
      var input = control.querySelector('.qty-control__input');
      if (minus && input) {
        minus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) input.value = val - 1;
        });
      }
      if (plus && input) {
        plus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          if (val < 99) input.value = val + 1;
        });
      }
    });

    /* ========================================
       COPY LINK — product sharing
       ======================================== */
    var copyBtn = document.getElementById('copy-link-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    }

    /* ========================================
       CART — remove item (hides row)
       ======================================== */
    document.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.cart-table__row');
        if (row) row.style.display = 'none';
      });
    });

    /* ========================================
       COLLECTION — filter drawer (mobile)
       ======================================== */
    var filterToggle = document.getElementById('filter-toggle');
    var filterDrawer = document.getElementById('filter-drawer');
    var filterOverlay = document.getElementById('filter-overlay');
    var filterClose = document.getElementById('filter-drawer-close');

    function openFilters() {
      if (filterDrawer) filterDrawer.classList.add('is-open');
      if (filterOverlay) filterOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      if (filterDrawer) filterDrawer.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    if (filterToggle) filterToggle.addEventListener('click', openFilters);
    if (filterClose) filterClose.addEventListener('click', closeFilters);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);

    /* ========================================
       COLLECTION — sort select
       ======================================== */
    var sortSelect = document.getElementById('sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        // Placeholder — wire up to Shopify collection sorting
      });
    }

  });
})();
